/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
/* eslint-disable */
// Init the trade carousel if it exists
var tradeCarousel = document.getElementsByClassName('TradeCarousel');
if (tradeCarousel.length) {
  new Flickity(tradeCarousel[0], tradeCarousel[0].dataset['flickity-config']);
}


//Sticky add to cart button
if($('.pdp_change_point')[0]){
  var visible, visible_top, visible_bottom;
    let scrollPos, pointToChange, bottom;
  //let screenHeight = window.outerHeightt;
  //let topQuantitySelector = $('.pdp_change_point').offset().top - 550;
  var breackPoint = 480;
  let topOffset = 133;
  let bottomOffset = 95; 
  
  function getButtonWidth(){
    if(window.innerWidth <= breackPoint){
      let buttonWidth = $('body').width() - ($('.ProductForm__AddToCart').offset().left * 2);
      $('.ProductForm__AddToCart').css('width', buttonWidth);
    }
  }
  getButtonWidth();

  $( window ).resize(function() {
    getButtonWidth();
  });


  window.addEventListener("scroll", function (e) {
   scrollPos = $('html').scrollTop();
    
   bottom = $(window).height() - $('.pdp_change_point').height();
   bottom = $('.pdp_change_point').offset().top - bottom +17;

  //console.log('scroll = ' + scrollPos + 'bottom = ' + bottom +  'visible = ' + visible + ' visible_top = ' + visible_top + ' visible_bottom = ' + visible_bottom);
    
   pointToChange = ($('.pdp_change_point').offset().bottom  - $(window).scrollTop()) < - topOffset;

      //console.log ('Bottom = ' + bottom + ' currentPos = ' + scrollPos + 'ooo' + ($('.pdp_change_point').offset().top  - $(window).scrollTop()));             

      if(window.innerWidth <= breackPoint){
        
      if( scrollPos <= (bottom + bottomOffset)  ){ //start position
       $('.ProductForm__AddToCart').css('position', 'fixed')
                              .css('bottom', '17px');
       //console.log('case1');
      }

      if( visible == 1 && visible_top == 1 ){
        $('.ProductForm__AddToCart').css('position', 'relative')
        .css('top', 'unset')  
        .css('bottom', 'unset');   
       //console.log('case2');   
      }
      if(visible_bottom == 0 && scrollPos > 600){ //fixed top
        $('.ProductForm__AddToCart').css('position', 'fixed')
        .css('top', '53px')
        .css('bottom', 'unset');
        //console.log('case3 + ' + $('.pdp_change_point').offset().top);
      }    
    }
  });
  
  $(window).on('resize scroll', function() {
    if ($('.pdp_change_point').isInViewport()) {
        // do something
      visible = 1;
      //console.log('visible_top');
    } else {
        // do something else
      visible= 0;
       //console.log('not visible');
    }
  
      if ($('.pdp_change_point_top').isInViewport()) {
        // do something
      visible_top = 1;
     //console.log('visible');
    } else {
        // do something else
      visible_top = 0;
      //console.log('not visible');
    }
  
      if ($('.pdp_change_point_bottom').isInViewport()) {
        // do something
      visible_bottom = 1;
      //console.log('visible_bottom');
    } else {
        // do something else
      visible_bottom = 0;
      // console.log('not visible');
    }
  });


  $.fn.isInViewport = function() {
      var elementTop = $(this).offset().top;
      var elementBottom = elementTop + $(this).outerHeight();

      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();

      return elementBottom > viewportTop && elementTop < viewportBottom;
  };
}// end PDP sticky button


jQuery(".ColorSwatch.ColorSwatch--small").click(function(e){
  let inputColor = this.previousSibling.previousSibling
  let variantUrl = "/products/" + inputColor.getAttribute('data-handle');
  let title = $(this).closest('.ProductItem__Wrapper').find('.ProductItem__Title').find('a');
  let image = $(this).closest('.ProductItem__Wrapper').find('.ProductItem__ImageWrapper');
  title.attr('href', variantUrl);
  image.attr('href', variantUrl);  
});

// Add Footer chat toggle event
const footerChatToggle = document.querySelector(".Footer__chat-toggle");
if (footerChatToggle) {
  footerChatToggle.addEventListener("click", function () {
    document.querySelector("iframe#chat-button").contentWindow.document.body.querySelector("#gorgias-chat-messenger-button").click();
  });
}

// Open the first collection filter collapse
const firstFilters = document.querySelectorAll('.Collapsible--first');
if (firstFilters.length > 0) {
  firstFilters.forEach(filter => {
    const toggleButton = filter.querySelector('button');
    if (toggleButton) {
      toggleButton.click();
    }
  })
}

const estimatedDeliverDates = Array.prototype.slice.call(document.querySelectorAll('[data-product-estimate-date]'));
if (estimatedDeliverDates) {
  const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  let today = new Date();
  const startDate = new Date(today.setDate(today.getDate() + 4));

  today = new Date();
  const endDate = new Date(today.setDate(today.getDate() + 11));

  let message = "Estimated Delivery ";
  if (startDate.getMonth() == endDate.getMonth()) {
    message += `${monthNames[startDate.getMonth()]} ${startDate.getDate()} - ${endDate.getDate()}`;
  } else {
    message += `${monthNames[startDate.getMonth()]} ${startDate.getDate()} - ${monthNames[endDate.getMonth()]} ${endDate.getDate()}`;
  }

  estimatedDeliverDates.forEach(element => element.textContent = message);
}